import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentProgressSummaryDetails from "./routes/StudentProgressSummaryDetails";
export default store => ({
  path: "student-progress-summary",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "student-progress-summary" */ "./StudentProgressSummary"
        ),
        import(
          /* webpackChunkName: "student-progress-summary" */ "./modules/StudentProgressSummaryModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "studentProgressSummary",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [StudentProgressSummaryDetails(store)],
});
